export default "__VITE_ASSET__D3g1jHQU__"